import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import textFileAttachment from 'src/examples/FileAttachment/text';
import imageFileAttachment from 'src/examples/FileAttachment/image';
import codeFileAttachment from 'src/examples/FileAttachment/code';
import spreadsheetFileAttachment from 'src/examples/FileAttachment/spreadsheet';
import queryFileAttachment from 'src/examples/FileAttachment/query';
import powerpointFileAttachment from 'src/examples/FileAttachment/powerpoint';
import withActionsFileAttachment from 'src/examples/FileAttachment/withAction';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  textFileAttachment,
  imageFileAttachment,
  codeFileAttachment,
  spreadsheetFileAttachment,
  queryFileAttachment,
  powerpointFileAttachment,
  withActionsFileAttachment,
  React
};